import React from 'react';

function ContactForm() {
   return (
      <section className="w-full bg-white py-12 md:py-16 lg:py-24 px-6">
         <div className="max-w-3xl mx-auto">
            <h3 className="text-title font-bold text-dark-1 mb-6 text-center">Formulaire de contact rapide</h3>
            <form className="space-y-4">
               <input type="text" placeholder="Nom" className="w-full border rounded-lg p-3 text-normal" />
               <input type="email" placeholder="Email" className="w-full border rounded-lg p-3 text-normal" />
               <select className="w-full border rounded-lg p-3 text-normal">
                  <option>Inscription</option>
                  <option>Devenir tuteur</option>
                  <option>Partenariat</option>
                  <option>Support technique</option>
                  <option>Autre</option>
               </select>
               <textarea placeholder="Message" rows={4} className="w-full border rounded-lg p-3 text-normal"></textarea>
               <button type="submit" className="px-6 py-3 border-2 text-button border-red-4 text-red-4 hover:bg-red-4 hover:text-white
              rounded-full transition-colors duration-300 font-medium">
                  Envoyer mon message
               </button>
            </form>
         </div>
      </section>
   )
};

export default ContactForm;